import { SUPPORT_ASSISTANT_ENABLED } from '$config/env'
import { openStudentSupportWapp, openSupportWapp } from '$logic/wapps/business'
import { getPvByUserId } from '$logic/pv'
import { openRoom } from '$logic/opened-room'
import { getProfile, UserRole } from '$logic/profile'
import { getUserByUsername } from '$logic/users'

const TEACHERS_SUPPORT_ACCOUNT_ID = 'teachers_support'
const STUDENTS_SUPPORT_ACCOUNT_ID = 'students_support'

const userRoleToSupportAccountId: Record<UserRole, string> = {
  [UserRole.STUDENT]: STUDENTS_SUPPORT_ACCOUNT_ID,
  [UserRole.TEACHER]: TEACHERS_SUPPORT_ACCOUNT_ID,
}
export async function openSupport() {
  const userProfile = getProfile()
  if (!userProfile) return

  const role = userProfile?.school?.role

  if (SUPPORT_ASSISTANT_ENABLED && role === UserRole.STUDENT)
    openStudentSupportWapp()
  else {
    const userRole = userProfile?.school?.role
    const supportAccountId = userRole
      ? userRoleToSupportAccountId[userRole] || ''
      : ''

    const user = await getUserByUsername(
      supportAccountId || userRoleToSupportAccountId[UserRole.STUDENT],
    )
    if (!user) return

    const pv = await getPvByUserId(user?.id)
    if (pv?.roomId) openRoom(pv.roomId)
  }
}
